import { translate } from 'vue-gettext'

const { pgettext } = translate

const TagScope = {
    MEDIA: {
        value: 'media',
        label: pgettext('tag_scope', 'Media'),
        description: pgettext('tag_scope.description', 'Photos and videos'),
        color: 'success'
    },
    CLUSTER: {
        value: 'cluster',
        label: pgettext('tag_scope', 'Cluster'),
        description: pgettext('tag_scope.description', 'Face clusters/groups'),
        color: 'secondary'
    }
}

export default TagScope

export const getAllTagScopes = () => {
    return Object.values(TagScope)
}

export const getTagScopeOptions = () => {
    return Object.values(TagScope).map(scope => ({
        value: scope.value,
        label: scope.label
    }))
}

export const getTagScopeByValue = (value) => {
    return Object.values(TagScope).find(s => s.value === value)
}

export const getTagScopeLabel = (scope) => {
    const scopeObj = getTagScopeByValue(scope)
    return scopeObj ? scopeObj.label : scope
}

export const getTagScopeColor = (scope) => {
    const scopeObj = getTagScopeByValue(scope)
    return scopeObj ? scopeObj.color : 'secondary'
}

export const getTagScopeDescription = (scope) => {
    const scopeObj = getTagScopeByValue(scope)
    return scopeObj ? scopeObj.description : ''
}

export const TAG_SCOPE_VALUES = Object.values(TagScope).map(s => s.value)

// Internal lowercase values (for database/internal use)
export const TAG_SCOPE_VALUE = {
    MEDIA: 'media',
    CLUSTER: 'cluster'
}

// Backend API returns scopes in uppercase format
export const TAG_SCOPE_API = {
    MEDIA: 'MEDIA',
    CLUSTER: 'CLUSTER'
}
